module.exports = __webpack_public_path__ + "static/media/1fed34fa-250a-4d32-9f1d-42f978a2e0b2.6e04b755.woff2";